export const IS_MOBILE = 'isMobile'
export const MOBILE = 'mobile'
export const IS_TABLET = 'isTablet'
export const TABLET = 'tablet'
export const IS_DESKTOP = 'isDesktop'
export const DESKTOP = 'desktop'
export const IS_WIDESCREEN = 'isWidescreen'
export const WIDESCREEN = 'widescreen'

/**
 * @typedef {[number, number]} Range Range between minimum and maximum value
 */

/**
 * Predefined screen size width ranges
 * @type {Object<string,Range>}
 * @readonly
 */
export const SIZES = {
  [MOBILE]: [0, 599],
  [TABLET]: [600, 839],
  [DESKTOP]: [840, 1279],
  [WIDESCREEN]: [1280, 0]
}
